import { Stack } from '@servicetitan/design-system';
import { BasicCard } from './demo/auto';
import { CustomCard } from './demo/manual';
import './styles.css';

export default {
    title: 'Skeleton/styles',
    parameters: {},
};

export const AutoStyles = () => (
    <Stack direction="column" spacing={2}>
        <BasicCard />
        <BasicCard className="skeleton-auto" />
    </Stack>
);

export const ManualStyles = () => (
    <Stack direction="column" spacing={2}>
        <CustomCard />
        <CustomCard className="skeleton" />
    </Stack>
);
